'use strict';

(function () {
	angular.module('app').filter('nwProductPrice', function () {
		return function (input) {
			return input.price || input.prices && input.prices.length && input.prices[0].price || null;
		};
	});
})();